'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import NoItems from '@/components/empty/no-items';
import { ProductCard } from '@/components/ui/cards';
import { Spinner } from '@/components/ui/forms';
import useWishlists from '@/hooks/useWishlists';
import NoFavouritesIcon from '@/components/ui/icons/no-favourites-icon';
const WishlistBody = ({ cols }) => {
  const t = useTranslations('');
  const { loading, wishlist_skus, wishlistProducts, hasMore, spinnerRef } =
    useWishlists();

  const wishlistSkuSet = useMemo(() => new Set(wishlist_skus), [wishlist_skus]);

  const filteredProducts = useMemo(
    () =>
      wishlistProducts?.filter((product) => wishlistSkuSet.has(product.sku)),
    [wishlistProducts, wishlistSkuSet]
  );
  if (loading) {
    return (
      <div className='mt-10 flex items-center justify-center'>
        <Spinner color='primary' />
      </div>
    );
  }

  if (!wishlist_skus?.length) {
    return (
      <NoItems
        title={t('user.no_products_title')}
        icon={
          <NoFavouritesIcon className='size-[270px] max-lg:size-[250px] max-md:size-[230px] max-sm:size-[216px]' />
        }
        description={t('common.no_products_description')}
        button={t('common.back_to_home')}
        buttonLink='/'
        titleClassName='max-sm:text-sm max-sm:font-semibold'
        descriptionClassName='max-sm:font-normal max-sm:text-xs max-sm:-mt-[9px]'
        parentClassName='max-sm:gap-[19px]'
        buttonClassName='max-sm:text-sm max-sm:font-semibold max-sm:h-9 p-0'
      />
    );
  }

  return (
    <div className={`grid ${cols} gap-4.25 xl:gap-8`}>
      {filteredProducts?.map((product) => (
        <ProductCard isFromWishList product={product} key={product?.sku} />
      ))}
      {hasMore && (
        <div
          className='col-span-full flex items-center justify-center'
          ref={spinnerRef}
        >
          <Spinner color='primary' />
        </div>
      )}
    </div>
  );
};

export default WishlistBody;
